export const statusTransfer = (status) => {
  let statusZh = status === 'ACTIVE' ? '运行'
    : status === 'BUILD' ? '构建中'
      : status === 'DELETED' ? '已永久删除'
        : status === 'ERROR' ? '错误'
          : status === 'HARD_REBOOT' ? '硬重启中'
            : status === 'MIGRATING' ? '迁移中'
              : status === 'PASSWORD' ? '重置密码中'
                : status === 'PAUSED' ? '暂停'
                  : status === 'REBOOT' ? '软重启中'
                    : status === 'REBUILD' ? '重建中'
                      : status === 'RESCUE' ? '救援模式中'
                        : status === 'RESIZE' ? '调整大小中'
                          : status === 'REVERT_RESIZE' ? '失败重启中'
                            : status === 'SHELVED' ? '搁置'
                              : status === 'SHELVED_OFFLOADED' ? '强制搁置'
                                : status === 'SHUTOFF' ? '关机'
                                  : status === 'SOFT_DELETED' ? '删除可还原'
                                    : status === 'SUSPENDED' ? '挂起'
                                      : status === 'UNKNOWN' ? '未知'
                                        : status === 'VERIFY_RESIZE' ? '等待确认'
                                          : status
  let color = status === 'ACTIVE' ? 'success'
    : status === 'BUILD' ? 'processing'
      : status === 'DELETED' ? 'error'
        : status === 'ERROR' ? 'error'
          : status === 'HARD_REBOOT' ? 'warning'
            : status === 'MIGRATING' ? 'warning'
              : status === 'PASSWORD' ? 'warning'
                : status === 'PAUSED' ? 'warning'
                  : status === 'REBOOT' ? 'warning'
                    : status === 'REBUILD' ? 'warning'
                      : status === 'RESCUE' ? 'warning'
                        : status === 'RESIZE' ? 'warning'
                          : status === 'REVERT_RESIZE' ? 'warning'
                            : status === 'SHELVED' ? 'error'
                              : status === 'SHELVED_OFFLOADED' ? 'error'
                                : status === 'SHUTOFF' ? 'error'
                                  : status === 'SOFT_DELETED' ? 'error'
                                    : status === 'SUSPENDED' ? 'warning'
                                      : status === 'UNKNOWN' ? 'warning'
                                        : status === 'VERIFY_RESIZE' ? 'warning'
                                          : 'warning'
  return {status: statusZh, color: color}
}
